import { FunctionComponent, h } from 'preact';
import Spinner from '../spinner/spinner';
import classNames from 'classnames';
import Translate from '../translate/translate';

interface Props {
	loading?: boolean;
	onOk?: () => void;
	onCancel?: () => void;
	type?: string;
	form?: string;
	okText?: string;
	cancelText?: string;
	className?: string;
}

const SharedLocationActions: FunctionComponent<Props> = ({
	loading,
	onOk,
	onCancel,
	type,
	form,
	okText,
	cancelText,
	className
}) => {
	return (
		<div className={classNames('shared-location-actions', className)} data-testid="shared-location-actions">
			<button
				className="shared-location-action-ok"
				data-testid="shared-location-action-ok"
				onClick={onOk}
				type={type}
				form={form}
			>
				{okText || <Translate text={'OK'} />}
				{loading && <Spinner className="shared-location-action-spinner" />}
			</button>
			<button
				className="shared-location-action-cancel"
				data-testid="shared-location-action-cancel"
				onClick={onCancel}
			>
				{cancelText || <Translate text={'CANCEL'} />}
			</button>
		</div>
	);
};

export default SharedLocationActions;
